module.exports = __webpack_public_path__ + "2729aa59c90d9e21cccd89bcee31c047.svg";